module.exports = __webpack_public_path__ + "static/media/(LH)-12-Capim-Dourado-bijuterias.525417fc.jpg";